import { render, staticRenderFns } from "./WaiterCarousel.vue?vue&type=template&id=6cedbc3b&scoped=true"
import script from "./WaiterCarousel.vue?vue&type=script&lang=js"
export * from "./WaiterCarousel.vue?vue&type=script&lang=js"
import style0 from "./WaiterCarousel.vue?vue&type=style&index=0&id=6cedbc3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cedbc3b",
  null
  
)

export default component.exports